const language = {
    'pt':
    {
        tipo_de_entidade: 'Tipo de Entidade',
        menus_perfis_entidade: 'Home / Entidades / Lista de Tipos de Entidade',
        add_new: 'Novo Tipo de Perfil',
        entidade: 'Entidade',
        entidades: 'Entidades',

        delete: 'Eliminar',
        delete_title: 'Eliminar registo',
        delete_text: 'Continuar?',
        delete_confirm: 'Sim',
        delete_cancel: 'Não',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        edit: 'Editar',
        edit_title: 'Editar registo',
        edit_text: 'Continuar?',
        edit_confirm: 'Sim',
        edit_cancel: 'Não',
        edit_error: 'Problema ao atualizar registo!',
        edit_success: 'Registo atualizado com sucesso!',
        insert_title: 'Novo registo',
        insert_text: 'Continuar?',
        insert_confirm: 'Sim',
        insert_cancel: 'Não',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        save: 'Salvar',
    },
    'en':
    {
        tipo_de_entidade: 'Entity Type',
        menus_perfis_entidade: 'Home / Entities / Entity Types List',
        add_new: 'New Entity Type',
        entidade: 'Entity',
        entidades: 'Entities',
        delete: 'Eliminar',
        delete_title: 'Eliminar registo',
        delete_text: 'Continuar?',
        delete_confirm: 'Sim',
        delete_cancel: 'Não',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        edit: 'Editar',
        edit_title: 'Editar registo',
        edit_text: 'Continuar?',
        edit_confirm: 'Sim',
        edit_cancel: 'Não',
        edit_error: 'Problema ao atualizar registo!',
        edit_success: 'Registo atualizado com sucesso!',
        insert_title: 'Novo registo',
        insert_text: 'Continuar?',
        insert_confirm: 'Sim',
        insert_cancel: 'Não',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        save: 'Salvar',
    },
    'es':
    {
      tipo_de_entidade: 'Tipo de entidad',
      menus_perfis_entidade: 'Inicio / Entidades / Lista de tipos de entidad',
      add_new: 'Nuevo tipo de perfil',
      entidade: 'Entidad',
      entidades: 'Entidades',
      delete: 'Eliminar',
      delete_title: 'Eliminar registro',
      delete_text: '¿Continuar?',
      delete_confirm: 'Sí',
      delete_cancel: 'No',
      delete_error: '¡Error al eliminar el registro!',
delete_success: '¡Registro eliminado con éxito!',
edit: 'Editar',
edit_title: 'Editar registro',
edit_text: '¿Continuar?',
edit_confirm: 'Sí',
edit_cancel: 'No',
edit_error: '¡Error al actualizar el registro!',
edit_success: '¡Registro actualizado con éxito!',
insert_title: 'Nuevo registro',
insert_text: '¿Continuar?',
insert_confirm: 'Sí',
insert_cancel: 'No',
insert_error: '¡Error al insertar el registro!',
insert_success: '¡Registro insertado con éxito!',
save: 'Guardar', 
    },
    'fr':
    {
tipo_de_entidade: 'Type d’entité',
menus_perfis_entidade: 'Accueil / Entités / Liste des types d’entité',
add_new: 'Nouveau type de profil',
entidade: 'Entité',
entidades: 'Entités',

delete: 'Supprimer',
delete_title: 'Supprimer l’enregistrement',
delete_text: 'Continuer ?',
delete_confirm: 'Oui',
delete_cancel: 'Non',
delete_error: 'Erreur lors de la suppression de l’enregistrement !',
delete_success: 'Enregistrement supprimé avec succès !',
edit: 'Modifier',
edit_title: 'Modifier l’enregistrement',
edit_text: 'Continuer ?',
edit_confirm: 'Oui',
edit_cancel: 'Non',
edit_error: 'Erreur lors de la mise à jour de l’enregistrement !',
edit_success: 'Enregistrement mis à jour avec succès !',
insert_title: 'Nouvel enregistrement',
insert_text: 'Continuer ?',
insert_confirm: 'Oui',
insert_cancel: 'Non',
insert_error: 'Erreur lors de l’insertion de l’enregistrement !',
insert_success: 'Enregistrement inséré avec succès !',
save: 'Enregistrer',
    },
}

module.exports = {
    language
};